import React from 'react';
import { iconType } from 'src/types';

const ImportIcon: React.FC<iconType.PropsType> = ({ className, onClick, color }) => {
  return (
    <div
      className={className && className}
      role="button"
      onClick={onClick && onClick}
      onKeyDown={onClick && onClick}
      tabIndex={onClick && -1}
      style={onClick ? { cursor: 'pointer', display: 'flex' } : { display: 'flex' }}
    >
      <svg
        id="Layer_1"
        version="1.1"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        height="27px"
        width="32px"
        fill={color || 'var(--primary_text_color)'}
      >
        <g>
          <path d="M44,31v12c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1V31H2v12c0,1.7,1.3,3,3,3h38c1.7,0,3-1.3,3-3V31H44z" />
          <polygon points="34.7,25.7 33.3,24.3 25,32.6 25,2 23,2 23,32.6 14.7,24.3 13.3,25.7 24,36.4  " />
        </g>
      </svg>
    </div>
  );
};

export default ImportIcon;
